const routes = {
  suppliers: 'Fleet'
};

export default routes;